import Fitmate from '../images/Fitmate.png'
import HorizonVideo from '../images/logo.png'
import Chatbot from '../images/Bot.jpg'
import Chat_Analyzer from '../images/chat.png'
import Crypto from '../images/crypto.png'
import Fraud from '../images/detection.png'
import Disease from '../images/disease.png'
import Movie from '../images/movie.png'
import Post from '../images/post.png'
import Certificate from '../images/certificate.png'
import Mentor from '../images/mentor.jpeg'




export const Bio = {
  name: "Ayush Jindal",
  roles: ["Software Engineer", "Backend Developer", "Data Analyst", "Golang Developer", "Business Analyst"],
  description:
  "Backend Software Engineer with experience building scalable APIs, distributed systems, cloud-native applications, and automation solutions using Golang, PostgreSQL, Redis, Docker, AWS, gRPC, and NATS. Passionate about solving business problems through software engineering and data analytics.",
  github: "https://github.com/jindalayush326",
  resume:
    "https://drive.google.com/file/d/1Gt6MSrzR-Fao9ZaWj0uTy5lF0QRkB4NQ/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ayush-jindal-684181219/",
  twitter: "https://x.com/jindalayush_?t=Xp9kmAnTAxUK5n0LZByoRw&s=09",
  insta: "https://www.instagram.com/jindalayush8_?utm_source=qr&igsh=bmhxMWZqYjQ4b2w=",
  email: "jindalayushaj@gmail.com"
};

export const skills = [
  {
    title: "Backend Development",

    skills: [
      {
        name: "Golang",
        image:
          "https://go.dev/blog/go-brand/Go-Logo/PNG/Go-Logo_Blue.png",
      },
      {
        name: "Gin Framework",
        image:
          "https://raw.githubusercontent.com/gin-gonic/logo/master/color.png",
      },
      {
        name: "GORM",
        image:
          "https://gorm.io/gorm.svg",
      },
      {
        name: "REST APIs",
        image:
          "https://cdn-icons-png.flaticon.com/512/2165/2165004.png",
      },
       {
        name: "gRPC",
        image: "https://grpc.io/img/logos/grpc-icon-color.png",
      },
      {
        name: "NATS",
        image: "https://avatars.githubusercontent.com/u/3732704?s=200&v=4",
      },
      {
        name: "Microservices",
        image: "https://cdn-icons-png.flaticon.com/512/2103/2103633.png",
      },
      {
        name: "PostgreSQL",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Redis",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
      },
      {
        name: "JWT",
        image:
          "https://cdn-icons-png.flaticon.com/512/1048/1048953.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
    ],
  },
   {
    title: "Data Analytics",

    skills: [
      {
        name: "SQL",
        image:
          "https://cdn-icons-png.flaticon.com/512/4248/4248443.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Power BI",
        image:
          "https://img.icons8.com/color/512/power-bi.png",
      },
      {
        name: "Microsoft Excel",
        image:
          "https://img.icons8.com/color/512/microsoft-excel-2019.png",
      },
      {
        name: "Pandas",
        image:
          "https://cdn.worldvectorlogo.com/logos/pandas.svg",
      },
      {
        name: "NumPy",
        image:
          "https://numpy.org/images/logo.svg",
      },
      {
        name: "Data Visualization",
        image:
          "https://cdn-icons-png.flaticon.com/512/2784/2784487.png",
      },
      {
        name: "Business Analytics",
        image:
          "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      },
      {
        name: "Dashboard Development",
        image:
          "https://cdn-icons-png.flaticon.com/512/1828/1828919.png",
      },
      {
        name: "Data Cleaning",
        image:
          "https://cdn-icons-png.flaticon.com/512/2942/2942789.png",
      },
    ],
  },
  {
    title: "Programming Languages",

    skills: [
      {
        name: "Go",
        image:
          "https://go.dev/blog/go-brand/Go-Logo/PNG/Go-Logo_Blue.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://cdn-icons-png.flaticon.com/512/226/226777.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
      {
        name: "SQL",
        image:
          "https://cdn-icons-png.flaticon.com/512/4248/4248443.png",
      },
    ],
  },
  {
    title: "Tools & Technologies",

    skills: [
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Linux",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "VS Code",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
    ],
  },
  {
    title: "Data Science",
    skills: [
      {
        name: "Langchain",
        image:
          "https://miro.medium.com/v2/resize:fit:1200/1*-PlFCd_VBcALKReO3ZaOEg.png",
      },
      {
        name: "Machine Learning",
        image:
          "https://static.vecteezy.com/system/resources/previews/013/899/429/non_2x/machine-learning-icon-artificial-intelligence-smart-machine-logo-template-illustration-free-vector.jpg",
      },
      {
        name: "Deep Learning",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjCSluZDDiflBgB9dmmsQae5EQEpW9xuvE8w&s",
      },
      {
        name: "NLP",
        image:
          "https://cdn-icons-png.freepik.com/512/9831/9831342.png",
      },
      {
        name: "GenAI",
        image:
          "https://img.freepik.com/free-vector/head-with-ai-chip_78370-3672.jpg",
      },
      {
        name: "Python Libraries",
        image:
          "https://s3.dualstack.us-east-2.amazonaws.com/pythondotorg-assets/media/community/logos/python-logo-only.png",
      },
      {
        name: "Gemini",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThr7qrIazsvZwJuw-uZCtLzIjaAyVW_ZrlEQ&s",
      },
      {
        name: "Streamlit",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYuX4Y0nAXZ6br6P7pwvVG7waXenE4mTsfKA&s",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Heroku",
        image:
          "https://w7.pngwing.com/pngs/434/165/png-transparent-heroku-original-wordmark-logo-icon-thumbnail.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Photoshop",
        image:
          "https://w7.pngwing.com/pngs/301/722/png-transparent-adobe-logo-logos-photoshop-logos-and-brands-icon-thumbnail.png",
      },
      {
        name: "Preimere Pro",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIYHHwdRgN5BgsSjZKGQ_Ij5zpseo2DXl7OQ&s",
      },
      {
        name: "Illustrator",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRA6kiNWTfkYHcDxY3V4w-NSg69GUKeIE_1DQ&s",
      },
      {
        name: "Figma",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfZYisM7kdYMiF96V0d4Y5QEtAOopmWWCsaw&s",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.greatplacetowork.in/great/api/assets/uploads/12013/logo/logo.png",
    company: "TechAhead Software Pvt. Ltd.",
    role: "Associate Software Engineer",
    date: "Apr 2026 - July 2026",

    desc:
      "Working as a Backend Software Engineer, developing scalable backend applications and RESTful APIs using Golang. Collaborating with cross-functional teams to build secure, high-performance solutions while optimizing database operations and application performance. Also involved in system design discussions, code reviews, and cloud-based deployments.",

    skills: [
      "Golang",
      "Gin",
      "REST APIs",
      "PostgreSQL",
      "MySQL",
      "Redis",
      "gRPC",
      "NATS",
      "Microservices",
      "Docker",
      "AWS",
      "Git",
    ],
  },
  {
    id: 1,
    img: "https://play-lh.googleusercontent.com/UURkNQZjHphPbGmYmLOSBhW-CfwQWLfV_-tA-F6WpeHJ_3m5Gbdfud9Wn8HcSuwFBkJWB9oisPboHMHqg_gY0BE",
    role: "Golang Developer",
    company: "FITPASS",
    date: "Sep 2025 - Mar 2026",
    desc:
      "Designed and developed backend services using Golang. Built an automated Load Testing Platform using Locust for configurable API performance testing. Integrated AWS Rekognition for Face Verification and Liveness Detection APIs. Worked with PostgreSQL, REST APIs, Docker, and backend automation to improve testing efficiency and service reliability.",
    skills: [
      "Golang",
      "Gin",
      "REST APIs",
      "PostgreSQL",
      "AWS Rekognition",
      "Docker",
      "Locust",
      "Redis",
      "Git",
      "Python",
    ],
  },
  {
  id: 2,
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTO2Sdyf5FB1BpZdRK3dZVP1Io_l2DpWaqiv-hQSiYjWw&s", // Import your logo
  role: "Founder & Product Developer",
  company: "FittVybe",

  date: "Dec 2024 – Jun 2025",

  desc:
    "Founded FittVybe, a health and fitness technology startup focused on delivering innovative digital solutions. Led product strategy, backend architecture, and business planning while building scalable applications and validating product ideas. Managed the complete product lifecycle from concept and market research to development, branding, and deployment.",

  skills: [
    "Entrepreneurship",
    "Product Development",
    "Backend Development",
    "REST APIs",
    "PostgreSQL",
    "AWS",
    "Business Strategy",
    "Market Research"
  ]
},
  {
    id: 3,
    img: "https://aftr.world/static/media/aftr-blue.e3941e466fbd05772133.webp",
    role: "Software Developer Intern",
    company: "AftrAI",
    date: "Jan 2024 - Mar 2024",
    desc: "Developed and implemented a sophisticated chatbot leveraging Gemini to extract pertinent information, enabling seamless interaction with users through natural language processing",
    skills: [
      "Langchain",
      "Gemini",
      "Postgresql",
      "Python",
      "Reactjs",
      "JavaScript",
      "Flask",
      "Firebase",
      " Node JS",
    ],
    doc: Certificate,
  },
  {
    id: 4,
    img: "https://media.licdn.com/dms/image/v2/C510BAQGSObrO0QPlMQ/company-logo_200_200/company-logo_200_200/0/1630597186826/girlscriptsoc_logo?e=2147483647&v=beta&t=hMIYqKIIlV3PFys0Ff4bQba_kZIMvychDesmF1_xmcU",
    role: "Mentor",
    company: "GirlScript Summer Of Code",
    date: "May 2024 - June 2024",
    desc: "Mentored in GSSoC’24 for the Dots-and-Boxes project, guiding contributors in developing an interactive python-based game. Provided technical support and code reviews to enhance project quality",
    skills: [
      "ReactJS",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: Mentor,
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvR2Y9JOZJ_8oNSR3zymDMy5WQ7VQuODDUQg&s",
    school: "Ajay Kumar Garg Engineering College",
    date: "Nov 2021 - May 2025",
    grade: "7.53 CGPA(I-Div With Distinction)",
    desc: "Completed Bachelor's in Computer Science & Engineering with specialization in Artificial Intelligence & Machine Learning. Gained strong foundations in Data Structures & Algorithms, Operating Systems, Computer Networks, Database Management Systems, Software Engineering, Artificial Intelligence, Machine Learning, Cloud Computing, and Backend Development. During the program, developed multiple backend applications, analytics dashboards, and real-world software engineering projects.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://www.schooldekho.org/storage/logo//7cmkgsfu48cokwwkw88sgsgg80w4wg8.png",
    school: "MJ Public School,Madnai",
    date: "May 2019 - Apr 2021",
    grade: "82%",
    degree:
      "Senior Secondary (CBSE) - Physics, Chemistry & Mathematics",

    desc:
      "Completed Higher Secondary Education with PCM, building a strong foundation in mathematics, logical reasoning, and analytical problem solving.",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRju1GxDjWH4UuFwKizdzSRMksTwfIJZCwoEg&s",
    school: "BLS International School, Hathras",
    date: "Apr 2016 - Apr 2019",
    grade: "94.8%",
     degree: "Secondary School (CBSE)",
    desc:
      "Completed secondary education with distinction, demonstrating strong academic performance and active participation in school activities.",
  },
];

export const projects = [
   {
    id: 0,
    title: "E-Auction Platform",
    date: "Apr 2026 - May 2026",

    description:
      "Developed a scalable backend for an online auction platform using Golang. Implemented secure authentication, bid management, auction lifecycle, RESTful APIs, and database optimization to support real-time bidding and high-performance transactions.",
    image: "https://backend.tpauctions.net//upload/slider/slider_3z9mq32gb0gms8zklej.jpeg", // Import your image
    tags: [
      "Golang",
      "Gin",
      "PostgreSQL",
      "Redis",
      "REST API",
      "JWT",
      "NATS",
      "gRPC",
      "Docker",
    ],

    category: "backend",
    github: "",
    webapp: "",
  },
  {
  id: 1,
  title: "Wealth Analytics & Portfolio Dashboard",
  date: "Jun 2026 - July 2026",

  description:
    "Contributed to the backend development of a digital wealth management platform for investment and portfolio management. Designed and implemented scalable RESTful APIs, optimized database queries, integrated third-party financial services, and enhanced application performance while ensuring secure and reliable data processing.",
  image: "https://static.fmgsuite.com/media/TransparentLogo/variantSize/4208890f-9cee-4134-9a97-3ad223c2f0f7.png",

  tags: [
    "Golang",
    "Gin",
    "REST APIs",
    "PostgreSQL",
    "Redis",
    "Docker",
    "AWS",
    "Microservices",
    "gRPC"
  ],
  category: "backend",
  github: "",
  webapp: ""
},
   {
    id: 2,
    title: "Load Testing Automation Platform",
    date: " Sept 2025",
    description:
      "Designed and developed an automation platform using Golang and Locust that automatically discovers APIs from web applications and generates configurable performance tests. Supports user count, spawn rate, test duration, and report generation.",
    image: "https://miro.medium.com/0*0Xhp3PN4SrbDYEHs.png",
    tags: [
      "Golang",
      "Python",
      "Locust",
      "Docker",
      "REST API",
      "Automation",
    ],
    category: "backend",
    github: "",
    webapp: "",
  },
  {
    id: 3,
    title: "Face Verification & Liveness Service",
    date: " Mar 2026",
    description:
      "Integrated AWS Rekognition APIs for face comparison and liveness detection. Developed backend APIs that securely verify user identity with high accuracy for onboarding and KYC workflows.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXwdVcHVozA97BEJVcwa8g9tERGKLXhGC8KcKoe3GPebvHsCLVthkalSSU&s=10",
    tags: [
      "Golang",
      "AWS",
      "Rekognition",
      "REST API",
      "Gin",
    ],
    category: "backend",
    github: "",
    webapp: "",
  },

  {
    id: 4,
    title: "Fitness Platform Backend",
    date: " Oct 2025",

    description:
      "Developed backend services for a fitness platform including authentication, user management, integrations, and scalable APIs while improving performance and maintainability of existing services.",

    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6d5BQtOxE5ska4nmm5Dnps-RZT0xjYM-3ILp2QRDgxg&s",

    tags: [
      "Golang",
      "PostgreSQL",
      "REST API",
      "Redis",
      "Docker",
    ],

    category: "backend",
    github: "",
    webapp: "",
  },

  {
    id: 5,
    title: "Sales Analytics Dashboard",
    date: "2026",

    description:
      "Interactive Moengage dashboard for sales performance analysis featuring KPIs, revenue trends, profit analysis, regional performance, and executive-level business insights.",

    image: "https://static.coupler.io/templates/crm-for-hubspot-dashboard.png",

    tags: [
      "CRM",
      "SQL",
      "Moengage",
      "Excel",
      "Data Visualization",
    ],

    category: "analytics",

    github: "",

    webapp: "",
  },
  {
    id: 6,

    title: "Financial Performance Dashboard",

    date: "2026",

    description:
      "Created a financial dashboard for tracking revenue, expenses, profit margin, and business KPIs with interactive filtering and visualization using Power BI.",

    image: "https://www.boldbi.com/wp-content/uploads/2026/01/financial-analysis-dashboard-v2.webp",

    tags: [
      "CRM",
      "SQL",
      "Excel",
      "Dashboard",
    ],

    category: "analytics",

    github: "",

    webapp: "",
  },

  {
    id: 7,

    title: "AI Fitness Assistant",

    date: "2024",

    description:
      "Built an AI-powered fitness assistant capable of generating personalized workout plans, calculating BMI, and answering health-related queries using Large Language Models.",

    image: Fitmate,

    tags: [
      "Python",
      "LangChain",
      "Gemini",
      "Flask",
      "React",
    ],
    category: "ai",
    github: "YOUR_GITHUB",
    webapp: "",
  },
  {
    id: 8,
    title: "Agriculture Bot",
    date: "May 2024",
    description:
      "Engineered AI-powered agriculture bot enabling farmers to upload crop images for analysis and receive personalized farming advice and solutions.",
    image: Chatbot,
    tags: [
      "React Js",
      "Langchain",
      "OpenAI",
      "Gemini",
      "Chatbot",
      "Flask",
      "Postgresql",
      "OnRender"
    ],
    category: "machine learning",
    github: "https://github.com/pradyumnpj/Agriculture-Bot",
    webapp: "https://agriculture-bot.onrender.com/",
  },
  {
    id: 9,
    title: "Hawk Chat Analyzer",
    date: "Dec 2023 - Jan 2024",
    description:
      "Chat Analyzer is an AI software solution to help organizations measure both sentiment and engagement on their chat platforms. This software takes text-based chat conversation data and finds out an individual’s emotions toward a particular topic.",
    image:Chat_Analyzer,
    tags: ["Python", "Javascript", "Streamlit", "Jupyter", "Numpy", "Pandas"],
    category: "machine learning",
    github: "https://github.com/jindalayush326/Hawk-Chat-Analyzer",
    webapp: "hawk-chat-analyzer.onrender.com/",
  },
  {
    id: 10,
    title: "Multiple Disease Prediction",
    date: "May 2023",
    description:
      "Multiple Disease Prediction like Heart Disease, Diabetes and Parkinson",
    image: Disease,
    tags: ["Python", "Jupyter", "Streamlit"],
    category: "machine learning",
    github: "https://github.com/jindalayush326/Multiple_Disease_Prediction",
    webapp: "https://github.com/jindalayush326/Multiple_Disease_Prediction",
  },
  {
    id: 11,
    title: "Fraud Detection App",
    date: "Jun 2023 - Jul 2023",
    description:
      "A Fraud Detection App made with Python, Javascript. Users can found for any fraud in Card, Mail, UPI, Pan Card, Aadhar Card, etc.",
    image: Fraud,
    tags: ["Python", "JavaScript", "Jupyter"],
    category: "machine learning",
    github: "https://github.com/jindalayush326/Sphinx",
    webapp: "https://github.com/jindalayush326/Sphinx",
  },
  {
    id: 12,
    title: "Infinity Hub Movie Website ",
    date: "Mar 2023",
    description:
      "Clone Similar to Netflix for watching movies, series, drama, cartoon,etc. ",
    image: Movie,
    tags: ["React Js", "Firebase", "RapidAPI", "Streamlit"],
    category: "web app",
    github: "https://github.com/jindalayush326/Infinity-Hub",
    webapp: "https://github.com/jindalayush326/Infinity-Hub",
  },
  {
    id: 13,
    title: "Crypto Trading Website",
    date: "Jul 2023",
    description:
      " A Trading App made with React JS and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the crypto price. ",
    image: Crypto,
    tags: ["React Js", "Local Storage", "Firebase", "RapidAPI"],
    category: "web app",
    github: "https://github.com/jindalayush326/Hawk",
    webapp: "https://github.com/jindalayush326/Hawk",
  },
  {
    id: 14,
    title: "Social Media Posts",
    date: "Jun 2022-Nov 2023",
    description:
      "Design the posts for festivals of Technomanegerial Society of AKGEC ie Horizon .",
    image: Post,
    tags: ["Adobe Photoshop", "Canva", "Adobe Illustrator","Figma"],
    category: "designing",
    github: "https://www.instagram.com/p/Cj0OERphmty/?img_index=1",
    webapp: "https://www.instagram.com/p/Cj0OERphmty/?img_index=1",
  },
  {
    id: 15,
    title: "Video Creator",
    date: "Jun 2022-Nov 2023",
    description:
      "Create the videos for festivals of Technomanegerial Society of AKGEC ie Horizon .",
    image: HorizonVideo,
    tags: ["Adobe PreimerePro", "Adobe After Effects", "Adobe Media Encoder"],
    category: "designing",
    github: "https://www.instagram.com/reel/Cm4DFgmhcuP/",
    webapp: "https://www.instagram.com/reel/Cm4DFgmhcuP/",
  },
];

export const TimeLineData = [
  {
    year: 2021,
    text: "Started B.Tech in Computer Science & Engineering (AI & ML) and built a strong foundation in programming, data structures, and software engineering.",
  },
  {
    year: 2022,
    text: "Developed full-stack applications and strengthened problem-solving skills through academic and personal projects.",
  },
  {
    year: 2023,
    text: "Built AI-powered applications and participated in hackathons, gaining experience in collaborative software development.",
  },
  {
    year: 2024,
    text: "Started professional software development journey through internships, working on backend systems, APIs, and cloud technologies.",
  },
  {
    year: 2025,
    text: "Specialized in Golang backend development by building scalable APIs, automation tools, AWS integrations, and production-grade applications.",
  },
  {
    year: 2026,
    text: "Working as an Associate Software Engineer while expanding expertise in Microservices, gRPC, NATS, Cloud Technologies, and Data Analytics.",
  },
];